module.exports = {"pt-BR":{"components":{"filterContainer":{"filteringBy":"Filtrando por:","submit":"Filtrar"}}}}